
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { FETCH_SOS_DATA_REQUEST } from '@src/middleware/actions/actionTypes';
import rootSaga from '@src/middleware/sagas/rootSaga';
import rootReducer from '@src/middleware/reducers/rootReducer';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({  thunk:false, serializableCheck: {
    ignoredActions: [FETCH_SOS_DATA_REQUEST],
    serializableCheck: false,
  }}).prepend(sagaMiddleware),

});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;



